import {useApp} from '@app';
import {useLayoutEffect} from 'react';
import {AuthApplication} from '@application/Auth';
import {TradeName} from '@domain/model/Config/Configuration';
import {ConfigurationApplication} from '@application/Config';
import {removeAuth} from '@infra/api/authManager/authManager';

export const useSessionAndTradeNameHandler = (): void => {
  const {setAuthorization} = useApp();

  useLayoutEffect(() => {
    AuthApplication.getLoginInfo().then(({tradeName}) => {
      // tradeName might be null so we cannot set the default in the function argument
      const td: TradeName = tradeName || TradeName.LOOKIERO;
      const currentTradeName = ConfigurationApplication.retrieve().tradename;

      if (currentTradeName !== td) {
        removeAuth().then(() => setAuthorization(null));
      }
    });
  }, [setAuthorization]);
};
